import React from 'react';

const VideoCard = ({ title, thumbnail, onClick }) => {
  return (
    <div className="video-card" onClick={onClick} style={{ cursor: 'pointer' }}>
      <div className="video-thumbnail">
        <img 
          src={thumbnail} 
          alt={title}
          loading="lazy"
          decoding="async"
        />
        <div className="video-hover-overlay">
          <span className="play-icon-large">▶</span>
          <span className="video-title">{title}</span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(VideoCard);